import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

// URL temporária do PDF de uma versão assinada. O arquivo precisa ser entregue exatamente como foi assinado.
export function useSignedDocumentFile() {
  const [isLoading, setLoading] = useState(false);

  const fetchUrl = useCallback((patientId, documentId, signatureId) => {
    setLoading(true);
    return quarkusApi
      .get(
        `/patients/${patientId}/documents/${documentId}/signatures/${signatureId}/signed-document`,
        {
          headers: { Authorization: sessionStorage.getItem('token') },
        },
      )
      .finally(() => setLoading(false));
  }, []);

  return { fetchUrl, isLoading };
}
